import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Painel Administrativo | K8";
    if (user && user.email) navigate("/admin/painel");
  }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/painel");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Falha no login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "#0A0A0E" }}>
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="mx-auto w-14 h-14 rounded-2xl accent-bar flex items-center justify-center text-black mb-4"><Lock size={24} /></div>
          <h1 className="font-head text-2xl font-black text-white">Painel Administrativo</h1>
          <p className="text-sm text-[var(--text-muted)] mt-1">Acesso restrito à equipe K8</p>
        </div>
        <form onSubmit={submit} className="card-surface p-6 space-y-4">
          <div><Label className="text-white">E-mail</Label><Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[var(--bg-secondary)] text-white" /></div>
          <div><Label className="text-white">Senha</Label><Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-[var(--bg-secondary)] text-white" /></div>
          <Button type="submit" disabled={loading} data-testid="admin-login-button" className="w-full btn-primary font-bold h-11">
            {loading ? <Loader2 className="animate-spin mr-2" size={18} /> : null} Entrar
          </Button>
        </form>
      </div>
    </div>
  );
}
